import PropTypes from "prop-types";

import { UnstractBlackLogo } from "../../assets";

let UnstractCloudLogo;
let LlmWhispererLogo;
try {
  UnstractCloudLogo =
    require("../assets/llmWhisperer/index.js").UnstractCloudLogo;
  LlmWhispererLogo =
    require("../assets/llmWhisperer/index.js").LlmWhispererLogo;
} catch {
  // The components will remain null of it is not available
}

function LoginLogo({ selectedProduct, productNames }) {
  if (
    selectedProduct !== productNames?.unstract &&
    selectedProduct !== productNames?.llmWhisperer &&
    UnstractCloudLogo
  ) {
    return <UnstractCloudLogo className="logo" />;
  }

  if (selectedProduct === productNames?.llmWhisperer && LlmWhispererLogo) {
    return <LlmWhispererLogo className="logo" />;
  }

  return <UnstractBlackLogo className="logo" />;
}

LoginLogo.propTypes = {
  selectedProduct: PropTypes.string,
  productNames: PropTypes.object,
};

export { LoginLogo };
